// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.required .el-form-item__label:before {\r\n  content: '*';\r\n  color: #F56C6C;\r\n  margin-right: 4px\n}\n.form-container {\r\n  max-height: 440px;\r\n  overflow:auto;\r\n  position:relative;\r\n  border: 1px solid #ccc;\r\n  margin-bottom:20px;\r\n  padding-top:20px;\r\n  padding-bottom:10px;\n}\r\n", ""]);
// Exports
module.exports = exports;
